import { IFRAME_GAME_URLS } from '~/configs/page-url'
import { useGames } from '~/composables/games/use-games'

export function useIframe() {
  const route = useRoute()
  const { getPlayGameUrl, getGameUrlIframe, getIframeGameMapGameApi } = useGames()
  const gameName = ref(route.params?.slug?.toString() ?? '')
  const gameURL = ref('')
  const classIframeBackground = ref('')
  if (gameName.value) {
    classIframeBackground.value = getClassIframe(`/${gameName.value.toString()}`)
  }

  function getClassIframe(slug: string): string {
    switch (slug) {
      case IFRAME_GAME_URLS.A_SPORTS:
      case IFRAME_GAME_URLS.M_SPORTS:
      case IFRAME_GAME_URLS.C_SPORTS:
      case IFRAME_GAME_URLS.K_SPORTS:
        return 'c-sports'
      case IFRAME_GAME_URLS.ESPORTS:
        return 'e-sports'
      case IFRAME_GAME_URLS.VIRTUAL_SPORTS:
        return 'virtual-sports'
      case IFRAME_GAME_URLS.VIRTUAL_GAME:
        return 'virtual-game'
      case IFRAME_GAME_URLS.KENO:
      case IFRAME_GAME_URLS.TP_KENO:
        return 'keno'
      case IFRAME_GAME_URLS.V_GAMING:
        return 'v-gaming'
      case IFRAME_GAME_URLS.NUMBER_GAME:
        return 'number-game'
      case IFRAME_GAME_URLS.LODE:
      case IFRAME_GAME_URLS.LODE_SIEUTOC:
      case IFRAME_GAME_URLS.LODE_DAICAT:
        return 'lo-de'
      case IFRAME_GAME_URLS.TABLE_GAMES:
        return 'table-games'
      case IFRAME_GAME_URLS.LOTTERY:
        return 'lottery'
    }
    return 'bg-default'
  }
  const checkIsIframe = computed(() => {
    return Object.values(IFRAME_GAME_URLS).includes(route.path)
  })

  async function getIframeUrl(): Promise<string | undefined> {
    return (await getPlayGameUrl(`${getIframeGameMapGameApi(route?.fullPath)}`))?.content ?? ''
  }

  // load game in client
  const getGameUrlClient = getGameUrlIframe(`/${gameName.value.toString()}`)
  if (getGameUrlClient) {
    gameURL.value = getGameUrlClient
  }

  const reloadGameIframe = async () => {
    const gameIframeElement = document.getElementById('gameFrame')
    if (gameIframeElement) {
      const newIframeUrl = (await getIframeUrl()) as string
      gameURL.value = newIframeUrl;
      (gameIframeElement as HTMLIFrameElement).src = newIframeUrl
    }
  }

  return {
    gameURL,
    classIframeBackground,
    checkIsIframe,
    reloadGameIframe,
    getIframeUrl
  }
}
